export default __webpack_public_path__ + "static/media/pause_video.65f79317.svg";